<template>
    <div>
        <div class="container-fluid min-content-height position-relative">
            <div class="loader-container">
                <div class="loader">
                    <i class="fas fa-spinner fa-pulse fa-10x"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DashboardLoader'
}
</script>